/* LuxCanva — Kit montaj tablou fara gauri: popup dupa adaugarea in cos + banda in pagina de cos.
 *
 * De ce fisier separat si nu in lc-addons: add-on-urile existente sunt bife FARA cantitate,
 * legate de formularul de produs. Kitul are nevoie de cantitate si apare in alte doua momente
 * (dupa add-to-cart si in cos), deci l-am tinut izolat ca sa nu ating ce functioneaza deja.
 *
 * Legatura cu tabloul: kitul NU primeste `_tpo_add_by`, pentru ca nu apartine unui tablou anume
 * (poate acoperi mai multe). Asa nu e sters de cascada din theme.liquid cand se scoate un tablou.
 */
(function () {
  'use strict';
  if (window.__lcKit) return;           // o singura instanta, indiferent cate sectiuni il includ
  window.__lcKit = true;

  var VARIANT_ID = 58532421468424;
  var PRODUCT_ID = 12205326893320;
  var PRET = 39.99;
  var PRET_TXT = '39,99 lei';
  var POZA = 'https://cdn.shopify.com/s/files/1/0717/9137/8696/files/kit-montaj-tablou-fara-gauri.png?width=320';
  var NUME = 'Kit montaj tablou, fără găuri';
  var DESC = 'Cârlig adeziv transparent și nivelă cu bulă. Fără bormașină, fără praf, fără găuri în perete.';
  var NOTA_LIMITA = 'Potrivit pentru tablouri de până la 150 cm pe latura mare.';
  var LATURA_MAX = 150;                 // peste asta adezivul nu mai tine — nu propunem kitul deloc
  var CHEIE_REFUZ = 'lcKitRefuzat';     // per sesiune, ca sa nu insiste dupa un refuz explicit

  var lei = function (n) { return n.toFixed(2).replace('.', ',') + ' lei'; };

  /* ---------- date despre cos ---------- */
  function cos() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function areKit(c) {
    return (c.items || []).some(function (i) { return i.variant_id === VARIANT_ID; });
  }
  function eAddon(i) {
    return i.product_type === 'Add-on' || (i.properties && (i.properties['_tpo_add_by'] || i.properties['_lc_parent']));
  }

  /* Latura cea mai mare a unui articol, din titlul variantei ("40 X 60 / Doar Sasiu Lemn / ...").
     Intoarce null cand nu gaseste dimensiuni — atunci NU blocam, ca sa nu ascundem kitul degeaba. */
  function laturaMare(i) {
    var t = [i.variant_title, i.title].filter(Boolean).join(' ');
    var m = t.match(/(\d{2,3})\s*[xX×]\s*(\d{2,3})/);
    return m ? Math.max(+m[1], +m[2]) : null;
  }

  /* Tablourile pentru care kitul chiar e potrivit: latura mare sub prag.
     Cele mari sunt sarite — adezivul nu tine un tablou de 180 cm, iar promisiunea
     s-ar intoarce ca reclamatie. */
  function nrTablouriPotrivite(c) {
    return (c.items || []).reduce(function (s, i) {
      if (eAddon(i)) return s;
      var L = laturaMare(i);
      if (L !== null && L > LATURA_MAX) return s;
      return s + i.quantity;
    }, 0);
  }
  // toate tablourile, indiferent de marime — ca sa stim daca cosul are macar un tablou
  function nrTablouri(c) {
    return (c.items || []).reduce(function (s, i) { return s + (eAddon(i) ? 0 : i.quantity); }, 0);
  }
  function adauga(qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: VARIANT_ID, quantity: qty, properties: { '_lc_kit': '1' } }] })
    }).then(function (r) { return r.json(); });
  }
  function reimprospateaza() {
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    cos().then(function (c) {
      document.querySelectorAll('[data-cart-count],[data-cart-total-count],.cart-count,.cart__count,.header__cart-count')
        .forEach(function (el) { el.textContent = c.item_count; });
    });
  }

  /* ---------- stiluri ---------- */
  var CSS = ''
    + '.lckit-ovl{position:fixed;inset:0;background:rgba(23,21,19,.55);z-index:99998;display:none;align-items:center;justify-content:center;padding:16px}'
    + '.lckit-ovl.on{display:flex}'
    + '.lckit-box{background:#fff;border-radius:14px;max-width:440px;width:100%;box-shadow:0 24px 60px rgba(0,0,0,.3);overflow:hidden;position:relative;font-family:inherit}'
    + '.lckit-x{position:absolute;top:10px;right:10px;width:32px;height:32px;border:0;border-radius:50%;background:rgba(23,21,19,.55);color:#fff;font-size:19px;line-height:1;cursor:pointer}'
    + '.lckit-x:hover{background:#171513}'
    + '.lckit-head{background:#F3EDE2;padding:12px 18px;font-size:13px;font-weight:700;color:#2a7a2a;display:flex;align-items:center;gap:7px}'
    + '.lckit-body{padding:18px}'
    + '.lckit-row{display:flex;gap:14px;align-items:flex-start}'
    + '.lckit-img{width:96px;height:96px;flex:none;border:1px solid #ececec;border-radius:10px;object-fit:contain;background:#fff}'
    + '.lckit-nume{margin:0 0 4px;font-size:16px;font-weight:700;color:#1B1712;line-height:1.25}'
    + '.lckit-desc{margin:0;font-size:13px;line-height:1.45;color:#6E6558}'
    + '.lckit-pret{margin:8px 0 0;font-size:17px;font-weight:700;color:#1B1712}'
    + '.lckit-limita{margin:7px 0 0 !important;font-size:12px;color:#8B8175;line-height:1.4}'
    + '.lckit-ctrl{display:flex;gap:10px;align-items:center;margin-top:16px}'
    + '.lckit-qty{display:flex;align-items:center;border:1px solid #ddd;border-radius:8px;overflow:hidden;flex:none}'
    + '.lckit-qty button{width:38px;height:44px;border:0;background:#fff;font-size:19px;line-height:1;cursor:pointer;color:#1B1712}'
    + '.lckit-qty button:hover{background:#f5f5f5}'
    + '.lckit-qty button:disabled{color:#ccc;cursor:not-allowed;background:#fff}'
    + '.lckit-qty input{width:44px;height:44px;border:0;text-align:center;font-size:15px;font-weight:700;color:#1B1712;-moz-appearance:textfield}'
    + '.lckit-qty input::-webkit-outer-spin-button,.lckit-qty input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}'
    + '.lckit-add{flex:1;height:44px;border:0;border-radius:8px;background:#A8843C;color:#fff;font-size:15px;font-weight:700;cursor:pointer;font-family:inherit}'
    + '.lckit-add:hover{filter:brightness(1.07)}'
    + '.lckit-add:disabled{opacity:.6;cursor:wait}'
    + '.lckit-nu{display:block;width:100%;margin-top:10px;background:none;border:0;color:#8B8175;font-size:13px;cursor:pointer;text-decoration:underline;font-family:inherit;padding:6px}'
    + '.lckit-nu:hover{color:#1B1712}'
    /* banda din pagina de cos */
    + '.lckit-cart{border:1px solid #E0D6C2;background:#FBFAF7;border-radius:10px;padding:14px;margin:16px 0;display:flex;gap:14px;align-items:center;flex-wrap:wrap}'
    + '.lckit-cart img{width:64px;height:64px;flex:none;object-fit:contain;border:1px solid #ececec;border-radius:8px;background:#fff}'
    + '.lckit-cart-txt{flex:1;min-width:170px}'
    + '.lckit-cart-txt p{margin:0}'
    + '.lckit-cart-nume{font-size:14px;font-weight:700;color:#1B1712}'
    + '.lckit-cart-desc{font-size:12px;color:#6E6558;line-height:1.4;margin-top:2px !important}'
    + '.lckit-cart .lckit-ctrl{margin-top:0;flex:none;width:100%}'
    + '@media(min-width:620px){.lckit-cart .lckit-ctrl{width:auto}.lckit-cart .lckit-add{flex:none;padding:0 20px}}'
    + '@media(max-width:479px){.lckit-row{gap:10px}.lckit-img{width:74px;height:74px}}';

  function stiluri() {
    if (document.getElementById('lckit-css')) return;
    var s = document.createElement('style');
    s.id = 'lckit-css'; s.textContent = CSS;
    document.head.appendChild(s);
  }

  /* ---------- bucata de comanda: cantitate + buton (refolosita in popup si in cos) ---------- */
  function control(qtyInitial, laAdaugare) {
    var wrap = document.createElement('div');
    wrap.className = 'lckit-ctrl';
    wrap.innerHTML = '<div class="lckit-qty">'
      + '<button type="button" data-m aria-label="Mai putin">&minus;</button>'
      + '<input type="number" min="1" max="20" value="' + qtyInitial + '" aria-label="Cantitate">'
      + '<button type="button" data-p aria-label="Mai mult">+</button></div>'
      + '<button type="button" class="lckit-add">Adaugă în coș</button>';

    var inp = wrap.querySelector('input');
    var minus = wrap.querySelector('[data-m]');
    var plus = wrap.querySelector('[data-p]');
    var add = wrap.querySelector('.lckit-add');

    function norm() {
      var n = parseInt(inp.value, 10);
      if (isNaN(n) || n < 1) n = 1;
      if (n > 20) n = 20;
      inp.value = n;
      minus.disabled = n <= 1;
      plus.disabled = n >= 20;
      return n;
    }
    minus.addEventListener('click', function () { inp.value = norm() - 1; norm(); });
    plus.addEventListener('click', function () { inp.value = norm() + 1; norm(); });
    inp.addEventListener('change', norm);
    inp.addEventListener('input', function () { if (inp.value !== '') norm(); });
    norm();

    add.addEventListener('click', function () {
      var n = norm();
      add.disabled = true; add.textContent = 'Se adaugă...';
      adauga(n).then(function () {
        add.textContent = 'Adăugat ✓';
        reimprospateaza();
        setTimeout(function () { laAdaugare && laAdaugare(n); }, 700);
      }).catch(function () {
        add.disabled = false; add.textContent = 'Adaugă în coș';
      });
    });
    return wrap;
  }

  /* ---------- popup ---------- */
  var ovl = null;
  function popup(qtySugerata) {
    stiluri();
    if (!ovl) {
      ovl = document.createElement('div');
      ovl.className = 'lckit-ovl';
      ovl.innerHTML = '<div class="lckit-box" role="dialog" aria-modal="true" aria-label="' + NUME + '">'
        + '<button class="lckit-x" type="button" aria-label="Închide">&times;</button>'
        + '<div class="lckit-head">✓ Tabloul a fost adăugat în coș</div>'
        + '<div class="lckit-body">'
        +   '<div class="lckit-row">'
        +     '<img class="lckit-img" src="' + POZA + '" alt="' + NUME + '">'
        +     '<div><p class="lckit-nume">' + NUME + '</p><p class="lckit-desc">' + DESC + '</p>'
        +     '<p class="lckit-pret">' + PRET_TXT + '</p>'
        +     '<p class="lckit-limita">' + NOTA_LIMITA + '</p></div>'
        +   '</div>'
        +   '<div id="lckit-ctrl-slot"></div>'
        +   '<button class="lckit-nu" type="button">Nu, mulțumesc</button>'
        + '</div></div>';
      document.body.appendChild(ovl);

      ovl.querySelector('.lckit-x').addEventListener('click', inchide);
      ovl.querySelector('.lckit-nu').addEventListener('click', function () {
        try { sessionStorage.setItem(CHEIE_REFUZ, '1'); } catch (e) {}
        inchide();
      });
      ovl.addEventListener('click', function (e) { if (e.target === ovl) inchide(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && ovl.classList.contains('on')) inchide();
      });
    }
    var slot = ovl.querySelector('#lckit-ctrl-slot');
    slot.innerHTML = '';
    slot.appendChild(control(qtySugerata, function () { inchide(); }));
    ovl.classList.add('on');
    document.body.style.overflow = 'hidden';
  }
  function inchide() {
    if (!ovl) return;
    ovl.classList.remove('on');
    document.body.style.overflow = '';
  }

  /* ---------- declansator: dupa ce se adauga un tablou in cos ---------- */
  // Nu ne bazam pe evenimentele temei: prindem chiar cererea catre /cart/add, deci merge
  // si pe paginile GemPages, si pe cele native, si din sertarul de cos.
  var ultimulPopup = 0;
  function poateAparea() {
    if (document.body.classList.contains('template-cart') || location.pathname.indexOf('/cart') === 0) return false;
    try { if (sessionStorage.getItem(CHEIE_REFUZ)) return false; } catch (e) {}
    return Date.now() - ultimulPopup > 3000;
  }
  function dupaAdaugare(idAdaugat) {
    if (idAdaugat && Number(idAdaugat) === VARIANT_ID) return;   // chiar kitul a fost adaugat
    if (!poateAparea()) return;
    cos().then(function (c) {
      if (areKit(c)) return;                    // decizia lui Horia: doar daca nu e deja in cos
      var t = nrTablouriPotrivite(c);
      if (!t) return;                           // niciun tablou, sau toate peste 150 cm
      ultimulPopup = Date.now();
      popup(Math.min(20, Math.max(1, t)));
    });
  }

  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var eAdd = url.indexOf('/cart/add') > -1;
    var id = null;
    if (eAdd && init && init.body) {
      try {
        var b = typeof init.body === 'string' ? JSON.parse(init.body) : null;
        if (b) id = b.id || (b.items && b.items.length === 1 && b.items[0].id);
      } catch (e) {}
    }
    var p = _fetch.apply(this, arguments);
    if (eAdd) p.then(function (r) { if (r.ok) setTimeout(function () { dupaAdaugare(id); }, 350); }).catch(function () {});
    return p;
  };

  // formularele clasice, care fac POST cu XHR (tema Expanse foloseste si asta)
  var _open = XMLHttpRequest.prototype.open, _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__lcUrl = u || ''; return _open.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    var x = this;
    if (String(x.__lcUrl).indexOf('/cart/add') > -1) {
      x.addEventListener('load', function () { if (x.status >= 200 && x.status < 300) setTimeout(function () { dupaAdaugare(null); }, 350); });
    }
    return _send.apply(this, arguments);
  };

  /* ---------- banda din pagina de cos ---------- */
  function bandaCos() {
    if (location.pathname.indexOf('/cart') !== 0) return;
    stiluri();
    cos().then(function (c) {
      var veche = document.getElementById('lckit-cart');
      var potrivite = nrTablouriPotrivite(c);
      // ascundem banda si cand toate tablourile din cos trec de 150 cm
      if (areKit(c) || !potrivite) { if (veche) veche.remove(); return; }
      if (veche) return;

      var box = document.createElement('div');
      box.className = 'lckit-cart';
      box.id = 'lckit-cart';
      box.innerHTML = '<img src="' + POZA + '" alt="' + NUME + '">'
        + '<div class="lckit-cart-txt"><p class="lckit-cart-nume">' + NUME + ' — ' + PRET_TXT + '</p>'
        + '<p class="lckit-cart-desc">' + DESC + '</p>'
        + '<p class="lckit-cart-desc lckit-limita">' + NOTA_LIMITA + '</p></div>';
      box.appendChild(control(Math.min(20, Math.max(1, potrivite)), function () {
        setTimeout(function () { location.reload(); }, 300);
      }));

      /* Tema Expanse are DOUA formulare de cos: unul in sertarul din antet (#HeaderCart,
         display:none pe pagina de cos) si unul in pagina. Prima versiune nimerea in sertar
         si banda nu se vedea niciodata. Alegem doar tinte chiar vizibile, din afara antetului. */
      function vizibil(el) {
        return el && el.getBoundingClientRect().height > 0 && !el.closest('.site-header, #HeaderCart, .site-header__drawer');
      }
      function prima(sel) {
        var l = Array.prototype.slice.call(document.querySelectorAll(sel));
        for (var i = 0; i < l.length; i++) if (vizibil(l[i])) return l[i];
        return null;
      }

      var buton = prima('.cart__checkout, [name="checkout"]');
      if (buton) {
        /* Urcam de la buton pana la copilul direct al lui .cart__page si inseram INAINTEA lui,
           ca banda sa stea deasupra zonei de finalizare. `insertBefore` cere ca reperul sa fie
           copil al gazdei — de aceea luam gazda DIN reper, nu invers (prima varianta arunca
           NotFoundError si banda nu aparea deloc). */
        var reper = buton;
        var pagina = buton.closest('.cart__page');
        if (pagina) { while (reper.parentNode && reper.parentNode !== pagina) reper = reper.parentNode; }
        var gazda = reper.parentNode;
        if (!gazda) return;
        gazda.insertBefore(box, reper);
      } else {
        var pag = prima('.cart__page') || prima('form[action*="/cart"]');
        if (!pag) return;
        pag.appendChild(box);
      }
    });
  }

  function porneste() { bandaCos(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', porneste);
  else porneste();
  document.addEventListener('cart:build', function () { setTimeout(bandaCos, 250); });
})();
